<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <mat-form-field class="lv-textarea" color="accent"
                    [floatLabel]="'never'"
                    [hideRequiredMarker]="true">
      <div class="lv-textarea-field" [ngClass]="{'lv-error-state': !!getError()}">
        <textarea matInput
                  #textarea="ngModel"
                  (ngModelChange)="changeValue($event)"
                  (blur)="onBlur()"
                  [name]="uiArtefakt.Identifikator"
                  [ngModel]="uiArtefakt.WertEingabe"
                  [maxlength]="uiArtefakt.AnzahlZeichenMaximum"
                  [minlength]="uiArtefakt.AnzahlZeichenMinimum"
                  [required]="uiArtefakt.PflichtfeldJN"
                  [disabled]="isDisabled"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="{{uiArtefakt.SichtbareZeilenMinimum}}"
                  cdkAutosizeMaxRows="{{uiArtefakt.SichtbareZeilenMaximum}}">
        </textarea>
        <mat-error class="lv-error-meldung-style-textarea" [ngClass]="uiArtefakt.BreiteInPixel"
                   *ngIf="getError() as error" (click)="onErrorClick()">
          <div class="lv-control-error"
               [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
        </mat-error>
      </div>
      <mat-hint *ngIf="!!extendedHint" [innerHTML]="extendedHint"></mat-hint>
    </mat-form-field>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
